import Cookies from 'js-cookie'

const TokenKey = 'School-Test-Token'

export function getToken() {
  const tk = Cookies.get(TokenKey)
  return tk
}

export function setToken(token) {
  if (process.env.DOMAIN) {
    return Cookies.set(TokenKey, token, {domain: process.env.DOMAIN})
  } else {
    return Cookies.set(TokenKey, token)
  }
}

export function removeToken() {
  if (process.env.DOMAIN) {
    return Cookies.remove(TokenKey, {domain: process.env.DOMAIN})
  } else {
    return Cookies.remove(TokenKey)
  }
}

export function checkLogin(that) {
  if (!getToken()) {
    const path = that.$route.path
    that.$router.push(`/login?t=${path}`)
    return false
  }
  return true
}

export function isLogin(that) {
  if (!getToken()) {
    // that.$router.push({path: '/login', query: {t: t}})
    that.$weui.alert('需要微信授权登录', {
      buttons: [{
        label: '登录',
        type: 'primary',
        onClick: function () {
          if (process.env.NODE_ENV === 'development') {
            setToken('k90zvAcrv/z4FdDX26OzI731SimqebdJCZEN6oCQhuGYxo1MeKMsLOk+sHBAcnoDX1hu50NlZD7mst9KNp6PhQ==')
          } else {
            const t = encodeURIComponent(location.pathname)
            const callback = encodeURIComponent(`http://live.dashark.cn/login?t=${t}`)
            const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${process.env.MP_APP_ID}&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect`
            console.log(url)
            location.href = url
          }
        }
      }]
    })
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/token.js